import classNames from "./Morse.module.css";

const Morse = () => {
  return (
    <svg
      width="264"
      height="80"
      viewBox="0 0 264 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames.Morse}
    >
      <circle cx="24" cy="24" r="24" fill="#EC6030" />
      <rect x="72" width="48" height="48" fill="#3C75EE" />
      <circle cx="168" cy="24" r="24" fill="#67DBDC" />
      <circle cx="240" cy="24" r="24" fill="#EC63DD" />
    </svg>
  );
};

export default Morse;
